export default {
    methods: {
        formatDate(timestamp) {
            if (!timestamp) return '';
      
            // Convert seconds to milliseconds
            const date = new Date(timestamp * 1000);
      
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = String(date.getFullYear()).slice(-2); // '25' from '2025'
      
            return `${day}/${month}/${year}`;
          },
    }
}
